import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../styles/adminlogin.css";
class AdminLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: ""
    };
  }

  loginAdmin = async () => {
    const res = await fetch("https://api.hi-bigame.online/admin/login",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: this.state.username,
          password: this.state.password
        })
      }
    );


    const data = await res.json();


    if (data.success) {
   
      localStorage.setItem("adminToken", data.token);

      this.props.navigate("/admin-dashboard", {
      replace: true
      });

    } else {
      alert("Invalid Admin ❌");
    }
  };


  render() {
    return (
      <div>
        <div className="admin-login-container">

          <div className="admin-login-box">

            <h1 className="admin-login-title">👑 Admin Login</h1>

            <input type="text" placeholder="Username" className="admin-login-input" onChange={(e) =>
              this.setState({ username: e.target.value })} />

            <input type="password" placeholder="Password" className="admin-login-input" onChange={(e) =>
              this.setState({ password: e.target.value })} />

            <button className="admin-login-btn" onClick={this.loginAdmin} > Login </button>

          </div>

        </div>
      </div>
    );
  }
}

export default withNavigation(AdminLogin); 